export const CONSENT_COOKIE_NAME = 'cookieconsent_status';
export const CONSENT_COOKIE = {
  allow: 'allow',
  deny: 'deny',
};
